import accordian from './components/accordian';
import slider from './components/slider';
import form from './components/form';
import smoothScroll from './components/smooth-scroll';

document.addEventListener('readystatechange', () => {
    if (document.readyState === 'complete') {
        accordian();
        slider();
        form();
        smoothScroll();
    }
});
